import { TSchemaBuilder } from "@pages/ManualDocumentV2/core";
import * as Yup from "yup";
import {
  customerSchema,
  documentInfoSchema,
  itemsSchema,
  totalsSchema,
  uploadSchema,
  vendorSchema,
} from "../../../_shared/schemaHelpers";

export const sdiCreditNoteSchema: TSchemaBuilder = (t) =>
  documentInfoSchema({
    t,
    documentClass: "CreditNote",
    poErrorKey: "poNumber_is_required",
    dueDateRequired: true,
    enforceDateOrder: true,
  })
    .concat(customerSchema(t))
    .concat(vendorSchema(t))
    .concat(itemsSchema(t))
    .concat(totalsSchema(t))
    .concat(uploadSchema()) as Yup.ObjectSchema<any>;
